import React, { Component } from 'react';
import TermConditions from './TermConditions.modal';
import PrivacyPolicy from './PrivacyPolicy.modal';

class GenericFooter extends Component {
  render() {
    return (
      <footer className={this.props.classes}>
        <hr />

        <div className="container">
          <div className="row">
            <div className="col">
              <p className="footer-title text-center text-bold text-less-margin text-16">&reg; Cellit.io | All rights reserved.</p>
              <p className="text-center text-less-margin text-14">By signing up, you agree to Cellit's 
                <button type="button" data-toggle="modal" data-target="#TermAndConditionsModal" onClick={this.handleModalOpen} className="modal-terms-link">Terms and Conditions </button>
                &amp; 
                <button type="button" data-toggle="modal" data-target="#PrivacyPolicyModal" onClick={this.handleModalOpen} className="modal-terms-link"> Privacy Policy</button>
              </p>
            </div>
          </div>
        </div>

        <TermConditions />

        <PrivacyPolicy />
      </footer>
    )
  }
}

export { GenericFooter as GenericFooterComponent };